import type { FaireProductEntity } from "../../entity_types/product";

export const p_zxjhvfjekd: FaireProductEntity = {
  token: "p_zxjhvfjekd",
  type: "product",
  name: "DreamTech Sleeveless Cowl Top with Shorts - Summer Sale",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/dd2238b147547b59eb643a9fa65e1926e9794c434cf500883829335475960d6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/094a5a1ddfeb3fbfa482789d9811e3aba89c26bfc5059d03cda000091d324e12.jpeg",
    "https://cdn.faire.com/fastly/821f7fd70c71691789ec93b3e13ad87f650a398fa1fb6589ae29b406370cceda.jpeg",
    "https://cdn.faire.com/fastly/668dcf5b573fbe4e878b9eaac472b9d4073d76ccd218c8daac871761b74a1079.jpeg",
    "https://cdn.faire.com/fastly/149457f3213c70fd82e7cef7b0df529c8fb50a77c12b55034623bd6dcde4d170.jpeg",
    "https://cdn.faire.com/fastly/32130a743427b6291b8fe79ca49625a3dd6da69fddadaa8d163df8f0255db300.jpeg",
    "https://cdn.faire.com/fastly/ed9bd579e1a796000d122a4477c28d9e304100e5bd7aa12748c377c5663bdd75.png",
    "https://cdn.faire.com/fastly/229729ebc92bf65be9babe3668686a940fa5ad029ecee12e64232a8e8cbeb20b.jpeg",
    "https://cdn.faire.com/fastly/bad4e72c1939422d34f0a756a454194d43ab185231f3485c12a9567e151edd51.jpeg",
    "https://cdn.faire.com/fastly/5b2f8023aeaa37b937c13c610e118726250a5affe3700f0eba2963b5964cb7fc.jpeg",
    "https://cdn.faire.com/fastly/c7bf2ccd8667ccbbf16ae106895dc525113e8a471b8b1e1cece45aec0988a4e2.jpeg",
    "https://cdn.faire.com/fastly/6c9184461be8b2d95f3af5801627d629acf88a310832b4e8e334ef6a73b23735.png"
  ],
  priceDollars: 60,
  description: "DreamTech Sleeveless Cowl Top with Pintuck Shorts\n\nEffortless style meets all-day comfort in our DreamTech Sleeveless Cowl Top with Pintuck Shorts. Crafted from DreamTech fabric, this set is smooth, softly structured, and cool to the touch — engineered for transitional dressing and busy days on the move.\n\nThe sleeveless cowl top drapes beautifully for a modern, relaxed silhouette, while the pintuck shorts add a refined touch with comfortable ease. With its subtly technical hand and buttery-soft finish, DreamTech delivers a streamlined, polished look without sacrificing comfort.\n\n𝐖𝐡𝐲 𝐲𝐨𝐮’𝐥𝐥 𝐥𝐨𝐯𝐞 𝐢𝐭:\n• Made from DreamTech — smooth, softly structured, and cool to the touch\n• Buttery-soft finish with a subtle technical feel\n• Sleeveless cowl top for a modern, draped silhouette\n• Pintuck shorts for a tailored yet comfortable fit\n• Perfect for travel, everyday wear, or effortless layering",
  tags: [],
  msrpDollars: 130,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:15.063Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
